import { PageObject, registerRouting } from "Common/routingUtils";
import Page from "./errorPanel/errorPanel";
import routingKeys from "./routingKeys";
registerRouting(routingKeys.ERROR, new PageObject(Page));
